import { PaymentLimitExceededRptService } from '../services';
import { PaymentLimitExceededRptConstants } from '../constants';
import { alertActions } from '.';

export const PaymentLimitExceededRptActions = {
    getAll,
    loadingData,
    exportData
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());

        PaymentLimitExceededRptService.fetchPaymentLimitExceededData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData));
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function request() { return { type: PaymentLimitExceededRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: PaymentLimitExceededRptConstants.GETALL_SUCCESS, datas } }
    function failure(error) { return { type: PaymentLimitExceededRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        PaymentLimitExceededRptService.fetchPaymentLimitExceededData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData));
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: PaymentLimitExceededRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: PaymentLimitExceededRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: PaymentLimitExceededRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: PaymentLimitExceededRptConstants.LOADING_REQUEST, isbool
    }
}
